import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Bootypage from './Bootypage';
import WelcomePage from './Pages2/WelcomePage';
import Quizpage from './Pages2/Quizpage';
import CourseSelection from './onboarding/preactivation/CourseSelection';
import FindCourseSkillLevel from './onboarding/preactivation/FindCourseSkillLevel';
import FindMySkillLevelStep2 from './onboarding/preactivation/FindMySkillLevelStep2';
import GetReadySkillTest from './onboarding/preactivation/GetReadySkillTest';
import OnboardingSkillTest from './onboarding/activation/OnboardingSkillTest';
// import OnboardingMultipleChoiceQuestion from './onboarding/activation/OnboardingMultipleChoiceQuestion';
// import OnboardingTrueFalse from './onboarding/activation/OnboardingTrueFalse';
import PostActivationQuotePage from './onboarding/postactivation/PostActivationQuotePage';
import PostActivationCoinsEarnedPage from './onboarding/postactivation/PostActivationCoinsEarnedPage';
import PostActivationStreakCountPage from './onboarding/postactivation/PostActivationStreakCountPage';
import PostActivationStreakCommitPage from './onboarding/postactivation/PostActivationStreakCommitPage';
import PostActivationStreakCommitRewardPage from './onboarding/postactivation/PostActivationStreakCommitRewardPage';
import CourseLanding from './course/CourseLanding';


const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Bootypage />} />
        <Route path="/quiz" element={<Quizpage />} />
        <Route path="/welcome" element={<WelcomePage />} />
        <Route path="/courses" element={<CourseSelection />} />
        <Route path="/find-course-skill-level" element={<FindCourseSkillLevel />} />
        <Route path="/find-my-skill-level-step" element={<FindMySkillLevelStep2 />} />
        <Route path="/get-ready-skill-test" element={<GetReadySkillTest />} />
        <Route path="/onboarding-skill-test-new" element={<OnboardingSkillTest />} />
        <Route path="/post-activation-quote" element={<PostActivationQuotePage />} />
        <Route path="/post-activation-coins-earned" element={<PostActivationCoinsEarnedPage />} />
        <Route path="/post-activation-streak-count" element={<PostActivationStreakCountPage />} />
        <Route path="/post-activation-streak-commit" element={<PostActivationStreakCommitPage />} />
        <Route path="/post-activation-streak-commit-reward" element={<PostActivationStreakCommitRewardPage />} />
        <Route path="/course-landing" element={<CourseLanding />} />


      </Routes>
    </Router>
  );
};

export default App;
